import { Box } from "@mui/material";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";
import ShCopyButton from "../../../theme/ShCopy";
import { ORDER_FILTER_KEYS } from "../../DataGrid/Filter";
import ShLabelSkeleton from "../../../theme/skeleton/ShLabelSkeleton";
import SHQuickAction from "../../../theme/Modal/SHQuickAction";
import ShLabel from "../../../theme/label/ShLabel";
import { getOrderStateData } from "../../../../utils/labelColorText";
import OrdersCard from "../../cards/orders/OrdersCard";
import { HighlightedColumn } from "./HighlightedColumn";
import RhOrdersCard from "./cards/RhOrdersCard";
import { formatPrice } from "../../../../utils/helpers";

export const rhFinancialColumns =  (i18n,theme,t,colors,columnStrategy) => {
    
    return [
        {
            field: "stream", 
            headerName: t("stream"),
            flex:1,
            filter: ORDER_FILTER_KEYS.STREAM,

            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if(columnStrategy !== null) {
                    if(columnStrategy.key === "invoiceproducts" || columnStrategy.key === "invoicproduct") {
                        const strat = columnStrategy.series.find(item => item.name === params.row.description);
                        if(strat) {
                            return (
                                <HighlightedColumn
                                    theme={theme}
                                    value={params.row.description}
                                    strat={strat}
                                />
                            )
                        }
                    }
                }
                return params.row.description
            }
        },

        {
            field: "invoice", 
            headerName: t("invoice"),
            flex:1,
            // filter: ORDER_FILTER_KEYS.RELATION,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            flexDirection:'column',
                        }}
                    >
                        <Text bold>{params.row.invoice.number}</Text>
                        <Text>{params.row.invoice.relation?.name}</Text>
                    </Box>
                )
            }
        },
        {
            field: "price", 
            headerName: t("price"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Text>
                        {formatPrice(i18n,params.row.price)}
                    </Text>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <RhOrdersCard
                        // selectable={params.row.state === general_states.OPEN}
                        // select={handleCardSelection} 
                        // selected={selectedItems.includes(params.row.id)} 
                        // onClick={() => getOrderDetails(params)} 
                        skeleton={params.row.skeleton ?? false} 
                        {...params.row}  
                    />
                )
            }
        }
    ]
};